import React, { useEffect, useContext } from "react"
import { useNavigate } from "react-router-dom"

import PaineisContext from "../../../contexts/Paineis"
import SelectTabs from "../../molecules/SelectTabs"
import Loading from "../../atoms/Loading"

export default function RcmpTabsSelectedPanels(props) {
  const { fnOnSelectPanel, ...oRest } = props

  const {
    selectedPaineis,
    getSelectedPaineis,
    handleOnClosePainel,
    handleSetSelectedPainel,
    fetchedSelectedPaineis,
    fnSetOCurrentPanel,
  } = useContext(PaineisContext)

  useEffect(() => {
    ;(async () => await getSelectedPaineis())()
  }, [])

  const fnNavigate = useNavigate()

  const fnToDashBoardPage = () => fnNavigate("/")

  const fnOnCloseTab = (oTab, bLastTab) => {
    handleOnClosePainel({ ...oTab, id: oTab.value })

    if (bLastTab) fnToDashBoardPage()
  }

  const fnOnSelecTab = (oTab, bIsHidden) => {
    fnSetOCurrentPanel(oTab)
    if (bIsHidden) handleSetSelectedPainel({ ...oTab, id: oTab.value })
    fnOnSelectPanel?.(oTab)
  }

  const aTabsData = selectedPaineis?.map((p) => {
    return {
      value: p?.id,
      label: p?.name,
      ...p,
    }
  })

  return (
    <>
      <Loading bShow={fetchedSelectedPaineis?.loading} />
      {!fetchedSelectedPaineis?.loading && (
        <SelectTabs
          tabs={aTabsData}
          onCloseTab={fnOnCloseTab}
          onSelectTab={fnOnSelecTab}
          {...oRest}
        />
      )}
    </>
  )
}
